export const PATH = "/notary-meeting-history";
